@if (!isWizardCompleted) {
  <div class="check-in-wizard"
    [class.check-in-wizard-kba-step]="isKbaQuestionsStep$ | async">
    <h1 class="check-in-wizard__title">
      Check-in: <span data-private>{{ userDisplayName$ | async }}</span>
    </h1>
    <app-step-tracker></app-step-tracker>
    @if (hasTask('TermsOfService')) {
      <app-terms-of-service [user]="user$ | async">
      </app-terms-of-service>
    }
    @if (hasTask('AudioVideoCheck')) {
      <app-audio-video-check-in-step>
      </app-audio-video-check-in-step>
    }
    @if (hasTask('CommissionSelection')) {
      <app-commission-selection
        [user]="user$ | async"
      ></app-commission-selection>
    }
    @if (hasTask('SignerDetails')) {
      <app-signer-details
        [user]="user$ | async"
      ></app-signer-details>
    }
    @if (hasTask('SignerDetailsVerification')) {
      <app-verify-signer-details
        [user]="user$ | async"
      ></app-verify-signer-details>
    }
    @if (hasTask('IdVerification')) {
      <app-id-verification-step-group
        [initialTasks]="initialTasks"
        [user]="user$ | async"
      ></app-id-verification-step-group>
    }
    @if (hasTask('SecurityQuestionInstructions')) {
      <app-kba-information
      ></app-kba-information>
    }
    @if (hasTask('SecurityQuestions')) {
      <app-kba-questions
      ></app-kba-questions>
    }
    @if (hasTask('SignatureCreation')) {
      <app-signature-creation
        [user]="user$ | async"
      ></app-signature-creation>
    }
    @if (hasTask('InitialsCreation')) {
      <app-initials-creation
        [user]="user$ | async"
      ></app-initials-creation>
    }
    @if (hasTask('SignatureConfirmation')) {
      <app-signature-confirmation
        [user]="user$ | async"
      ></app-signature-confirmation>
    }
  </div>
}
